
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.visually-hidden{clip-path:inset(50%);height:1px;overflow:hidden;position:absolute!important;width:1px}.tufts-icon-button{background-color:var(--white);border:1px solid var(--black-400);border-radius:var(--br-min);display:flex;flex-direction:column;height:10em;margin:auto;overflow:hidden;padding:var(--spacing-4);place-content:center;place-items:center;text-decoration:none;width:100%}.tufts-icon-button:hover{text-decoration:underline}.tufts-icon-button:focus{outline:3px solid #000}.label{color:var(--medium-blue);font-family:var(--ff-body);font-weight:700;margin-top:1rem;text-align:center}`;